/** Issues request tickets so only the most recently started request may apply its outcome. */
export const useLatestRequest = () => {
  let latestTicket = 0

  const begin = (): number => {
    latestTicket += 1
    return latestTicket
  }

  const isLatest = (ticket: number): boolean => ticket === latestTicket

  return { begin, isLatest }
}
